import {
  GET_CALL_CENTER_AGENTS_LOG_SUCCESS,
  GET_CALL_CENTER_AGENTS_SUCCESS,
  GET_SERVICE_USERS_SUCCESS,
} from '../actionConstants';

const defaultState = {
  list: {},
  log: {},
  serviceUsers: [],
};

export default (state = defaultState, action) => {
  const { type, res } = action;
  switch (type) {
    case GET_CALL_CENTER_AGENTS_SUCCESS:
      if (Array.isArray(res?.data)) {
        return { ...state, list: { results: res?.data } };
      }
      return { ...state, list: res?.data };
    case GET_CALL_CENTER_AGENTS_LOG_SUCCESS:
      return { ...state, log: res?.data };
    case GET_SERVICE_USERS_SUCCESS:
      return { ...state, serviceUsers: res?.data || [] };
    case '@@router/LOCATION_CHANGE':
      return defaultState;
    default:
      return state;
  }
};
